import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

import Button from 'shared/components/Button'

export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  span {
    color: ${colors.green};
  }
  padding-bottom: 40px;
`

export const ContainerInputs = styled.div`
  text-align: center;

  @media (max-width: 425px) {
    & > div > input {
      width: 10vw;
      height: 5.2vh;
      min-width: unset;
    }
  }
`

export const TextButton = styled.button`
  background: transparent;
  border: none;
  color: ${colors.green};
`

export const StyledInput = styled.input`
  width: 100%;

  border: 1px solid ${colors.grayLight};
  border-radius: 4px;

  padding: 12px 10px;

  font-weight: 400;
  font-size: 12px;

  margin: 10px 0px;
  background-color: ${colors.white};
`

export const StyledError = styled.p`
  width: 100%;
  color: red;
  padding-top: 10px;
  font-weight: 400;
  font-size: 12px;
`

export const ContainerForm = styled.div`
  display: flex;

  flex: 1;

  flex-direction: column;
  align-items: center;

  input {
    max-width: 513px;
  }

  & p {
    text-align: center;
  }
`

export const StyledButton = styled(Button)`
  position: absolute;
  bottom: 20px;

  @media (max-width: 1377px) {
    position: relative;
    bottom: -150px;
  }

  @media (max-height: 668px) {
    bottom: -120px;
  }
`
export const ResendButton = styled(Button)`
  margin-bottom: 10px;
  width: 185px;
`

export const Container = styled.div`
  width: 100%;
  display: flex;

  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`
